import React, { Component } from 'react';
import { PaymentElement, AddressElement } from '@stripe/react-stripe-js';
import { withNamespaces } from 'react-i18next';

class CheckoutForm extends Component {
	constructor(props) {
		super(props);

		this.handlePaymentElementChange = this.handlePaymentElementChange.bind(this);

		this.state = {
			selectedPaymentMethodType: null
		}
	}

	componentDidMount() {
		const handleFormSubmit = () => {
			const { elements } = this.props;
			// trigger form validation and wallet collection
			return elements.submit();
		};

		const handlePayment = (authorizationToken, returnUrl) => {
			const { stripe, elements } = this.props;
			return stripe.confirmPayment({
				elements,
				clientSecret: authorizationToken,
				confirmParams: {
					return_url: returnUrl,
				},
				redirect: 'if_required'
			});
		};

		this.props.onInit({ stripeSubmitHandle: handleFormSubmit, stripePaymentHandle: handlePayment });
	}

	handlePaymentElementChange(event) {
		this.setState({ selectedPaymentMethodType: event.value.type });
	}

	render() {
		const { payment: { parent }, countryCode, t } = this.props;
		return <div>
			<PaymentElement
				options={{
					defaultValues: {
						billingDetails: {
							email: parent.email,
							name: parent.fullName,
							phone: parent.phoneNumber
						}
					}
				}}
				onChange={this.handlePaymentElementChange}
			/>
			{/* Afterpay/Clearpay requires shipping address to be provided */ }
			{this.state.selectedPaymentMethodType === 'afterpay_clearpay' && <React.Fragment>
				<h5>{t('FO_Parent_Address')}</h5>
				<AddressElement
					options={{
						mode: 'shipping',
						allowedCountries: ['AU', 'CA', 'NZ', 'GB', 'US'],	// countries supported by Afterpay/Clearpay
						defaultValues: {
							name: parent.fullName,
							address: {
								line1: parent.address,
								postal_code: parent.postcode,
								country: countryCode
							}
						}
					}} />
			</React.Fragment>
			}
		</div>;
	}
}

export default withNamespaces()(CheckoutForm);